import Dropdown from "@/components/UI/Dropdown/Dropdown";

import styles from './UserDropdown.module.scss'
import {useCookies} from "react-cookie";
import {signOut as fbSignOut} from "@firebase/auth";
import {auth} from "@/services/firebase.service";
import Icon from "@/components/UI/Icon/Icon";
import {useEffect} from "react";
import Button from "@/components/UI/Button/Button";
import {useIsAdmin} from "@/lib/useIsAdmin";
import {useRouter} from "next/router";

type Props = {}

const  UserDropdown = ({}: Props) => {

  const router = useRouter()
  const [cookies, _setCookies, removeCookies] = useCookies(['displayName'])
  const isAdmin = useIsAdmin()

  const signOut = () => {
    fbSignOut(auth)
    removeCookies('displayName', { path: '/' })
  }

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user) {
        _setCookies('displayName', user.displayName || '', { path: '/' })
      } else {
        removeCookies('displayName', { path: '/' })
      }
    })
    return () => {
      unsubscribe()
    }
  }, []);

  const redirect = router.basePath + router.asPath

  if (!cookies.displayName) return  <div className={styles.buttonContainer}>
    <a href={`/signin?utm_source=games&utm_medium=Nav&redirect=${redirect}`}><Button simple>Sign In</Button></a>
    {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
    <a href={`/signup?utm_source=games&utm_medium=Nav&redirect=${redirect}`}><Button>Sign Up</Button></a>
    </div>

    return (
    <Dropdown
      direction="right"
      trigger={<label className={styles.userDropdownButton}><Icon icon="user"/>&nbsp;{cookies.displayName}</label>}
      entries={

      [
        ...(isAdmin ? [
          {type: 'link' as 'link', href: '/chg-admin', text: 'Admin Page'},
          {type: 'link' as 'link', href: '/crossword', text: 'Public Crossword Page'},
          {type: 'divider' as 'divider'},
        ] : []),

        {type: 'link' as 'link', href: 'https://edhrec.com/account', text: 'My Account'},
        {type: 'entry', text: 'Sign out', onClick: signOut}
      ]}
      />
  )
}

export default UserDropdown